import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp24};
`

export const ChartsContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(
    auto-fill,
    minmax(max(320px, calc((100% - 2 * ${props => props.theme.spacing.sp16}) / 3)), 1fr)
  );
  gap: ${props => props.theme.spacing.sp16};
`
